const buildVXCPortfolioAuditCsvData = (response) => {
  const header = [
    'Portfolio',
    'Event',
    'Time'
  ];
  let data = [];
  if (!response) {
    console.error('Records were not found in json file from S3. There should always be a records data element whether the array is populated or empty');
  } else {
    data = response.map(record =>
      [record.portfolio,
        record.action,
        record.timestamp
      ]);
  }
  data.unshift(header);

  return data;
};

export default buildVXCPortfolioAuditCsvData;


// WEBPACK FOOTER //
// ./src/helpers/reports/csv/buildVXCPortfolioAuditCsvData.js